var _path, _path2, _rect, _rect2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPatientChatNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.3125 23.0742H66.9375C67.7052 23.0742 68.4415 23.379 68.9844 23.9219C69.5272 24.4647 69.832 25.2011 69.832 25.9688V54.4688C69.832 55.2364 69.5272 55.9728 68.9844 56.5156C68.4415 57.0585 67.7052 57.3633 66.9375 57.3633H62.707V67.1055L53.1602 57.5586L52.9639 57.3633H31.3125C30.5448 57.3633 29.8085 57.0585 29.2656 56.5156C28.7228 55.9728 28.418 55.2364 28.418 54.4688V25.9688C28.418 25.2011 28.7228 24.4647 29.2656 23.9219C29.8085 23.379 30.5448 23.0742 31.3125 23.0742Z",
    fill: "#E3EDC3",
    stroke: "#274642",
    strokeWidth: 1.33594
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0625 15.9492H52.6875C53.4552 15.9492 54.1915 16.254 54.7344 16.7969C55.2772 17.3397 55.582 18.0761 55.582 18.8438V47.3438C55.582 48.1114 55.2772 48.8478 54.7344 49.3906C54.1915 49.9335 53.4552 50.2383 52.6875 50.2383H31.0361L30.8398 50.4336L21.293 59.9805V50.2383H17.0625C16.2948 50.2383 15.5585 49.9335 15.0156 49.3906C14.4728 48.8478 14.168 48.1114 14.168 47.3438V18.8438C14.168 18.0761 14.4728 17.3397 15.0156 16.7969C15.4906 16.3219 16.1138 16.0297 16.7764 15.9639L17.0625 15.9492Z",
    fill: "white",
    stroke: "#274642",
    strokeWidth: 1.33594
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 23.5,
    y: 21.5,
    width: 23,
    height: 23,
    rx: 11.5,
    fill: "#E3EDC3"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 23.5,
    y: 21.5,
    width: 23,
    height: 23,
    rx: 11.5,
    stroke: "#274642"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0004 26.6C35.4105 26.6002 35.7481 26.9093 35.7943 27.307L35.8002 27.3998V32.1996H40.6C41.0416 32.1996 41.3995 32.5578 41.3998 32.9994C41.3998 33.4095 41.0914 33.7479 40.6937 33.7943L40.6 33.8002H35.8002V38.6C35.8001 39.0416 35.442 39.3996 35.0004 39.3998C34.5901 39.3998 34.2517 39.0906 34.2054 38.6927L34.1996 38.6V33.8002H29.3998C28.958 33.8001 28.6 33.4412 28.6 32.9994C28.6002 32.5893 28.9093 32.2516 29.307 32.2054L29.3998 32.1996H34.1996V27.3998C34.1996 26.958 34.5586 26.6 35.0004 26.6Z",
    fill: "#274642"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatientChatNew);
export default __webpack_public_path__ + "static/media/patient_chat_new.38b87693838b5da36a3bc191cffb49e7.svg";
export { ForwardRef as ReactComponent };